import constants from '../../ahm-constants';

const {
  URLS: {
    SALES: { EXPLAINED },
  },
} = constants;

type SanityTerm = {
  identifier?: {
    current: string;
  };
  detailsTeaser?: string;
  urlObject?: {
    name: string;
    url: string;
  };
};

const getLinkFromSanityTerm = ({ detailsTeaser, identifier, urlObject }: SanityTerm) => {
  const urlName = urlObject?.name;
  const url = urlObject?.url;

  if (urlName && url) {
    return { link: url, linkText: urlName };
  }

  const slug = identifier?.current;
  const ctaPath = slug ? `${EXPLAINED}/${slug}` : null;

  if (ctaPath && detailsTeaser) {
    return { link: ctaPath, linkText: detailsTeaser };
  }

  return null;
};

export default getLinkFromSanityTerm;
